module.exports = __webpack_public_path__ + "img/icon_export.bff88e14.svg";